export const getBrowserPhoneDisableMessage = (config, t) => {
  switch (config?.browserPhoneDisableReason) {
    case "AGENT_EXTENSION_MISSING":
      return t("ccBrowserPhoneMissingExtension");
    case "AGENT_EMAIL_MISSING":
      return t("ccBrowserPhoneMissingEmail");
    case "SDK_NOT_CONFIGURED":
      return t("ccBrowserPhoneSdkNotConfigured");
    case "BROWSER_PHONE_DISABLED":
      return t("ccBrowserPhoneFlagDisabled");
    case "CALLING_DISABLED":
      return t("ccBrowserPhoneOrgCallingDisabled");
    case "WEB_CALLING_DISABLED":
      return t("ccBrowserPhoneWebCallingDisabled");
    case "DESKTOP_CALLING_DISABLED":
      return t("ccBrowserPhoneDesktopCallingDisabled");
    case "GRANDSTREAM_DESKTOP_ONLY":
      return t("ccBrowserPhoneGrandstreamDesktopOnly");
    case "GRANDSTREAM_WEBRTC_DISABLED":
      return t("ccBrowserPhoneGrandstreamWebrtcDisabled");
    case "GRANDSTREAM_WSS_NOT_CONFIGURED":
      return t("ccBrowserPhoneGrandstreamWssNotConfigured");
    case "GRANDSTREAM_NOT_CONFIGURED":
      return t("ccBrowserPhoneGrandstreamNotConfigured");
    default:
      return t("ccBrowserPhoneNotEnabled");
  }
};
